<template>
  <div>
    <h2>Closures</h2>
    <p class="text-muted">
      Closures mark specific dates that you would like to prevent bookings for,
      e.g. Bank Holidays. Click on a date to mark it as CLOSED. If you wish to
      undo a CLOSED date, simply click on the date again.
    </p>
    <b-row>
      <b-col>
        <FullCalendar
          defaultView="dayGridMonth"
          :header="calendarHeader"
          :plugins="calendarPlugins"
          :events="calendarEvents"
          @dateClick="e => toggleDate(e.dateStr)"
          @eventClick="e => toggleEvent(e)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  components: {
    FullCalendar
  },
  data() {
    return {
      calendarHeader: {
        left: 'title',
        right: 'prev,next today'
      },
      calendarPlugins: [dayGridPlugin, interactionPlugin],
      editableStore: null
    };
  },
  methods: {
    ...mapActions({
      updateStore: 'stores/updateStore'
    }),
    async toggleDate(date) {
      if (this.editableStore.holidays[date]) {
        delete this.editableStore.holidays[date];
      } else {
        this.editableStore.holidays[date] = true;
      }

      try {
        this.updateStore(this.editableStore);
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    },
    async toggleEvent(e) {
      this.toggleDate(moment(e.event.start).format('YYYY-MM-DD'));
    }
  },
  computed: {
    ...mapGetters({
      store: 'stores/store'
    }),
    calendarEvents() {
      const holidays = _.get(this.editableStore, 'holidays');
      return !holidays
        ? []
        : _.map(Object.keys(holidays), date => {
            // holiday is in format YYYY-MM-DD
            return {
              id: date,
              start: date,
              end: date,
              overlap: false,
              title: 'CLOSED',
              color: 'rgba(220,53,69, 0.67)'
            };
          });
    }
  },
  watch: {
    store: {
      deep: true,
      immediate: true,
      handler(value) {
        this.editableStore = _.cloneDeep(value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
</style>
